<template>
    <div class="entidades">
        <div class="container">
            <h2>ENTIDADES</h2>
            <div class="row entidades-div">
            <div class="col-md-4"><img src="@/assets/entidad-1.jpg"></div>
            <div class="col-md-4"><img src="@/assets/entidad-2.jpg"></div>
            <div class="col-md-4"><img src="@/assets/entidad-3.jpg"></div>
            </div>
        </div>
    </div>
</template>

<script>

export default {

}
</script>


<style scoped>

@media screen and (min-width: 200px) {

    h2 {
    color: #5a5a5a !important;
    text-align: center;
    font-size: 2.4em;
    margin-bottom: 40px !important;
    margin-top: 0;
}

.entidades-div {
    text-align: center;
}

.col-md-4 {
    margin-bottom: 60px;

}

.entidades-div img {
    max-width: 200px;
}

.entidades {
    padding: 6em 0;
    text-align: center;
}

}

@media screen and (min-width: 990px) {

h2 {
    font-size: 3.5em;
    margin-bottom: 80px !important;
}

.col-md-4 {
    margin-bottom: 0px;    
}

.entidades-div img {
    max-width: 120px;
}

.entidades {
    padding: 8em 0;
    text-align: center;
}
    
}



</style>